import React, { useState, useEffect } from 'react';
import { useParams, Link, useLocation } from 'react-router-dom';
import axios from 'axios';
import { Box, Grid, Typography, Card, Button, IconButton, Chip, Skeleton, Avatar, Paper, Rating } from '@mui/material';
import { Dialog, DialogActions, DialogContent, DialogTitle, Checkbox, FormControlLabel } from '@mui/material';
import { Facebook, Instagram, X, LinkedIn, YouTube } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import Header1 from '../Header/Header1';
import Footer from '../Footer/Footer';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import ReportIcon from '@mui/icons-material/Report';
import ShareButton from "../Share/ShareButton";
import Footer2 from '../Footer/Footer2';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import RequestRecommendations from '../Recommendations/RequestRecommendations';
import avatar from './default-avatar.png'
import ShareIcon from '@mui/icons-material/Share';
import FlagIcon from '@mui/icons-material/Flag';
import { styled } from '@mui/system';
import DeleteIcon from "@mui/icons-material/Delete";
import { PersonOutline } from '@mui/icons-material';
import OTPValidationRequest from '../OTP/OTPValidationRequest';
import FeedbackFormMyRequests from '../Feedback/FeedbackFormMyRequests';
import GoogleMeetLogo from '../Post/GoogleMeetImage.png';
import ZoomMeetLogo from '../Post/ZoomMeetImage.png';
import TeamsMeetLogo from '../Post/TeamsMeetImage.png';
import YouTubeEmbed from '../UserProfile/YouTubeEmbed';
import CancelSessionMyRequestsButton from '../Cancellations/CancellSessionMyRequestsButton';
import ViewsLikesAnalyticsRequest from './ViewsLikesAnalyticsRequest';
import MeetingGuidelines from '../Guidelines/MeetingGuidelines';



const API_URL = process.env.REACT_APP_API_URL;


const MyRequestTabDetails = ({ onLogout }) => {

  useEffect(() => {
    window.scrollTo(0, 0);  // Scroll to top when this page is loaded
  }, []);


  const { id, userId } = useParams();
  const navigate = useNavigate();
  const [course, setCourse] = useState(null);
  const [action, setAction] = useState(null);
  const location = useLocation();
  const [bookingCreated, setBookingCreated] = useState(false)
  const paymentStatus = location.state?.paymentStatus || 'unknown';  // Default to 'unknown' if not provided

  const [bookedUsers, setBookedUsers] = useState([]);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);


  const [openDialog, setOpenDialog] = useState(false); // To control the dialog's visibility
  const [isChecked, setIsChecked] = useState(false); // To track checkbox state

  // Fetch booked users when component mounts or when postId changes
  useEffect(() => {
    const fetchBookedUsers = async () => {
      try {
        const response = await axios.get(`${API_URL}/accepted_users/?request_id=${id}`);
        if (response.status === 200) {
          setBookedUsers(response.data);
        }
      } catch (error) {
        console.error("Error fetching booked users:", error);
      }
    };

    if (id) {
      fetchBookedUsers();
    }
  }, [id]);

  const getLogo = (platform) => {
    switch (platform) {
      case 'googleMeet':
        return GoogleMeetLogo;
      case 'zoom':
        return ZoomMeetLogo;
      case 'microsoftTeams':
        return TeamsMeetLogo;
      default:
        return null; // Optionally, you can return a default image or a placeholder here
    }
  };


  const getPlatformName = (platform) => {
    switch (platform) {
      case 'googleMeet':
        return 'Google Meet';
      case 'zoom':
        return 'Zoom';
      case 'microsoftTeams':
        return 'Microsoft Teams';
      default:
        return null;
    }
  };


  const handleJoinClick = () => {
    setOpenDialog(true); // Open the dialog
  };

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked); // Update checkbox state
  };

  const handleConfirmAndJoin = () => {
    if (isChecked) {
      // Use navigate to redirect to the meeting link
      window.open(course.meeting_link, '_blank'); // Open in a new tab
      setOpenDialog(false); // Close the dialog
    } else {
      alert('Please confirm that you understand the instructions.');
    }
  };

  // Function to handle rejection
  const handleReject = async (bookingId) => {
    try {
      const response = await axios.post(`${API_URL}/reject_booking/`, { booking_id: bookingId });
      if (response.status === 200) {
        // Update local state to reflect rejection
        setBookedUsers(prevUsers => prevUsers.filter(user => user.id !== bookingId));
      }
    } catch (error) {
      console.error("Error rejecting booking:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${API_URL}/get_requested_data/?request_id=${id}`);
        setCourse(response.data[0]);

      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, [id, userId]);  // Depend on 'id' and 'userId' to ensure the data and view count is fetched only once


  const handleDelete = async () => {
    try {
      const response = await axios.delete(`${API_URL}/delete_request/?request_id=${id}`);
      if (response.status === 200) {
        alert("Request deleted successfully!");
      }
    } catch (error) {
      console.error("Error deleting post:", error);
      alert("Failed to delete the post");
    }
  };


  useEffect(() => {
    const getUserPostInteraction = async () => {
      try {
        const response = await axios.get(
          `${API_URL}/get_user_post_interaction/`,
          {
            params: {
              user_id: userId,
              post_id: id,
            },
          }
        );
        setAction(response.data.action); // Set the action (like, dislike, or null)
      } catch (error) {
        setAction(null);
        console.error("Error fetching user post interaction:", error);
      }
    };

    getUserPostInteraction();
  }, [userId, id]);

  const handleLogout = () => {
    onLogout();
    navigate('/login');
  };

  if (!course) {
    return <Typography variant="h6" sx={{ textAlign: "center", padding: "2rem" }}>Loading...</Typography>;
  }

  const formatStartTime = (time) => {
    const [hours, minutes] = time.split(':');
    const dateObj = new Date();
    dateObj.setHours(hours);
    dateObj.setMinutes(minutes);

    const formatter = new Intl.DateTimeFormat('en-US', {
      hour: '2-digit', minute: '2-digit', hour12: true
    });

    return formatter.format(dateObj); // returns time in AM/PM format
  }

  const formatDuration = (durationInMinutes) => {
    const hours = Math.floor(durationInMinutes / 60);
    const minutes = durationInMinutes % 60;

    if (hours > 0) {
      return `${hours} hour${hours > 1 ? 's' : ''} ${minutes} minute${minutes !== 1 ? 's' : ''}`;
    }

    return `${minutes} minute${minutes !== 1 ? 's' : ''}`;
  };

  const formatExperience = (experience) => {
    // If experience exists and is in the format HH:MM
    if (experience) {
      let minutes = experience.split(':')[0];  // Extract the minute value before ":"
      return `${minutes} min`;
    } else {
      return "New user";  // If no experience, return "New user"
    }
  }


  const {
    topic_name, section_name, subsection_name, description, language, date, start_time,
    duration, name, surname, profile_picture,
    about, rating, experience, id: cardId, price, user_id, meeting_link,
    facebook, instagram, x, linkedin, youtube, likes, dislikes, specialized_fields, roles, meeting_platform,
  } = course;

  const durationFormatted = formatDuration(duration)
  const teacherRating = rating || "Not rated yet";
  const formattedStartTime = formatStartTime(start_time);
  const formatedExperience = formatExperience(experience)





  const handleConfirmBooking = (booking_id) => {
    axios
      .post(`${API_URL}/confirm_booking/`, { booking_id: booking_id, user_id: userId })
      .then((response) => {
        if (response.data.status === 'success') {
          alert('Booking confirmed!');
          window.location.reload()
        }
      })
      .catch((error) => {
        console.error("Error confirming booking:", error);
      });
  };




  const handleShareClick = () => {
  };



  const handleRedirect = () => {
    navigate('/meeting-guidelines');  // Redirect to meeting guidelines page
  };


  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };


  return (
    <div>
      <Header1 userId={userId} onLogout={onLogout} />
      <Typography
        variant="h3"
        component="h1"
        align="center"
        fontSize={{ xs: '2rem', sm: '2.5rem', md: '3rem' }}
        sx={{
          backgroundImage: 'linear-gradient(45deg, #00bfff, #ff00ff)',
          mt: 10,
          letterSpacing: 7,
          WebkitBackgroundClip: 'text',  // This makes the gradient clip to the text
          color: 'transparent',  // Makes the text itself transparent to show the gradient
        }}
        gutterBottom
      >
        My Request Session View
      </Typography>
      <Box sx={{
        backgroundColor: "#000000", minHeight: "100vh", marginTop: "50px", marginBottom: "100px", px: { xs: 1, sm: 3, md: 5 }, // Responsive horizontal padding
        overflowX: "hidden",         // 💥 Prevent horizontal scroll
        width: "100%",
      }}>
        <Grid
          container
          spacing={3}
          justifyContent="center"
          sx={{
            backgroundColor: "#000000",
            width: "100%",
            margin: 0,
            padding: 0,
            overflowX: "hidden", // 💥 Just in case something leaks here
          }}
        >

          <Grid container justifyContent="center">
            <Box sx={{
              padding: { xs: "1.5rem", sm: "2rem", md: "3rem", lg: "4rem" },// Responsive padding
              backgroundColor: "#2222", // Darker background for modern look
              color: "#fff",
              borderRadius: "16px",
              height: "100%",
              boxSizing: "border-box",
              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
              "&:hover": {
                transform: "translateY(-5px)",
                boxShadow: "0 8px 20px rgba(0, 0, 0, 0.3)",
              },
            }}>




              <Box sx={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: "1rem" }}>
                <Avatar sx={{
                  width: 150,
                  height: 150,
                  // mr: 2,
                }} src={`${API_URL}${profile_picture}` || '/default-avatar.png'} alt={name || 'User'} />



                <Box sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  mt: 2, // Margin top for some space between the image and the icons
                }}>


                </Box>
              </Box>


              <Box sx={{ textAlign: 'center', marginTop: '1rem', padding: '1rem', width: '100%' }}>

                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: "bold",
                    color: "#fff",
                    letterSpacing: 5,
                    fontFamily: "'Helvetica', sans-serif",
                    "&:hover": { color: '#1E90FF' },
                    fontSize: { xs: '1.2rem', sm: '1.5rem', md: '1.8rem' },  // Responsive font size
                  }}
                >
                  {name || "name"} {surname || "surname"}
                </Typography>



              </Box>



              <Typography
                variant="h6"
                sx={{
                  fontWeight: 500,
                  marginBottom: "1.5rem",
                  color: "#fff",
                  letterSpacing: 1,
                  textAlign: "center",
                  fontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
                  fontSize: {
                    xs: '1rem',   // small phones
                    sm: '1.2rem', // tablets
                    md: '1.4rem', // small desktops
                    lg: '1.55rem' // large desktops
                  },
                  lineHeight: 1.6,
                  "&:hover": {
                    color: '#1E90FF',
                  },
                }}
              >
                "{description}"
              </Typography>

              <Grid container spacing={3} justifyContent="center" sx={{ mt: 1 }}>

                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: "bold",
                    color: "#fff",
                    background: "linear-gradient(45deg, #333333, #555555)",

                    borderRadius: "8px",
                    padding: "6px 12px",
                    mr: 1,
                    letterSpacing: 2,
                    mt: 1,
                    textTransform: "uppercase",
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.2)",
                    display: "inline-block",
                    fontSize: "0.875rem", // Smaller size for compactness
                    letterSpacing: "0.8px",
                    transition: "transform 0.3s ease-in-out, background 0.3s ease-in-out",
                    "&:hover": {
                      background: "linear-gradient(45deg, #6e7dff, #6b89ff)",
                      transform: "scale(1.05)",
                    },
                    "@media (max-width: 600px)": {
                      fontSize: "0.75rem", // Make text smaller on mobile
                      padding: "4px 10px", // Adjust padding for smaller screens
                    },
                  }}
                >
                  Language: {language || "N/A"}
                </Typography>

                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: "bold",
                    color: "#fff",
                    background: "linear-gradient(45deg, #333333, #555555)",
                    borderRadius: "8px",
                    padding: "6px 12px",
                    textTransform: "uppercase",
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.2)",
                    display: "inline-block",
                    mr: 1,
                    mt: 1,
                    letterSpacing: 2,
                    fontSize: "0.875rem", // Smaller size for compactness
                    letterSpacing: "0.8px",
                    transition: "transform 0.3s ease-in-out, background 0.3s ease-in-out",
                    "&:hover": {
                      background: "linear-gradient(45deg, #6e7dff, #6b89ff)",
                      transform: "scale(1.05)",
                    },
                    "@media (max-width: 600px)": {
                      fontSize: "0.75rem", // Make text smaller on mobile
                      padding: "4px 10px", // Adjust padding for smaller screens
                    },
                  }}
                >
                  Price: {`\u20B9`}{price}
                </Typography>

                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: "bold",
                    color: "#fff",
                    background: "linear-gradient(45deg, #333333, #555555)",

                    borderRadius: "8px",
                    padding: "6px 12px",
                    textTransform: "uppercase",
                    mr: 1,
                    mt: 1,
                    letterSpacing: 2,
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.2)",
                    display: "inline-block",
                    fontSize: "0.875rem", // Smaller size for compactness
                    letterSpacing: "0.8px",
                    transition: "transform 0.3s ease-in-out, background 0.3s ease-in-out",
                    "&:hover": {
                      background: "linear-gradient(45deg, #6e7dff, #6b89ff)",
                      transform: "scale(1.05)",
                    },
                    "@media (max-width: 600px)": {
                      fontSize: "0.75rem", // Make text smaller on mobile
                      padding: "4px 10px", // Adjust padding for smaller screens
                    },
                  }}
                >
                  Date: {date || "N/A"}
                </Typography>


                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: "bold",
                    color: "#fff",
                    background: "linear-gradient(45deg, #333333, #555555)",

                    borderRadius: "8px",
                    padding: "6px 12px",
                    textTransform: "uppercase",
                    mr: 1,
                    mt: 1,
                    letterSpacing: 2,
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.2)",
                    display: "inline-block",
                    fontSize: "0.875rem", // Smaller size for compactness
                    letterSpacing: "0.8px",
                    transition: "transform 0.3s ease-in-out, background 0.3s ease-in-out",
                    "&:hover": {
                      background: "linear-gradient(45deg, #6e7dff, #6b89ff)",
                      transform: "scale(1.05)",
                    },
                    "@media (max-width: 600px)": {
                      fontSize: "0.75rem", // Make text smaller on mobile
                      padding: "4px 10px", // Adjust padding for smaller screens
                    },
                  }}
                >
                  Start Time: {formattedStartTime || "N/A"}
                </Typography>

                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: "bold",
                    color: "#fff",
                    background: "linear-gradient(45deg, #333333, #555555)",

                    borderRadius: "8px",
                    padding: "6px 12px",
                    textTransform: "uppercase",
                    mr: 1,
                    mt: 1,
                    letterSpacing: 2,
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.2)",
                    display: "inline-block",
                    fontSize: "0.875rem", // Smaller size for compactness
                    letterSpacing: "0.8px",
                    transition: "transform 0.3s ease-in-out, background 0.3s ease-in-out",
                    "&:hover": {
                      background: "linear-gradient(45deg,  #6e7dff, #6b89ff)",
                      transform: "scale(1.05)",
                    },
                    "@media (max-width: 600px)": {
                      fontSize: "0.75rem", // Make text smaller on mobile
                      padding: "4px 10px", // Adjust padding for smaller screens
                    },
                  }}
                >
                  Duration: {durationFormatted}
                </Typography>



              </Grid>

              <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                sx={{
                  letterSpacing: 3,
                  padding: { xs: '16px', sm: '24px', md: '32px' }, // responsive padding
                  textAlign: 'center',
                  width: '100%', // ensures box takes full width
                }}
              >
                {getLogo(meeting_platform) ? (
                  <img
                    src={getLogo(meeting_platform)}
                    alt={meeting_platform}
                    style={{
                      letterSpacing: 3,
                      width: '80px', // default width for small screens
                      height: 'auto', // preserve aspect ratio
                      maxWidth: '100px', // maximum width for larger screens
                    }}
                  />
                ) : (
                  <span style={{ fontStyle: 'italic', color: 'gray', letterSpacing: 3 }}>
                    Meeting Platform Info Not available
                  </span>
                )}

                <Typography
                  variant="body1"
                  sx={{
                    letterSpacing: 3,
                    marginTop: '12px',
                    fontSize: { xs: '14px', sm: '16px', md: '18px' }, // responsive font size
                    fontWeight: 500,
                    color: '#333',
                  }}
                >
                  {getPlatformName(meeting_platform)} {/* Call getPlatformName() properly */}
                </Typography>
              </Box>

              <Grid container spacing={2} justifyContent="center" alignItems="center" sx={{ mt: 2 }}>

                {/* Delete Button */}
                <Grid item xs={12} sm="auto" sx={{ textAlign: 'center' }}>
                  {bookedUsers && bookedUsers.length === 0 ? (
                    <Button
                      variant="outlined"
                      color="error"
                      startIcon={<DeleteIcon />}
                      onClick={handleDelete}
                      sx={{
                        letterSpacing: 4,
                        width: { xs: '100%', sm: 'auto' },  // Full width on small screens, auto on larger screens
                        padding: { xs: '0.75rem 1rem', sm: '0.875rem 1.5rem' },  // Adjust padding for different screen sizes
                        fontSize: { xs: '0.875rem', sm: '1rem' },  // Adjust font size for responsiveness
                        marginTop: { xs: '1rem', sm: '1.5rem' },  // Adjust margin top for spacing
                      }}
                    >
                      Delete
                    </Button>
                  ) : null}
                </Grid>

                {/* Meeting Instructions Button */}
                <Grid item xs={12} sm="auto" sx={{ textAlign: 'center' }}>
                  <Button
                    variant="contained"
                    color="info"
                    onClick={handleRedirect}
                    sx={{
                      letterSpacing: 4,
                      width: { xs: '100%', sm: 'auto' },  // Full width on small screens, auto on larger screens
                      padding: { xs: '0.75rem 1rem', sm: '0.875rem 1.5rem' },  // Adjust padding for different screen sizes
                      fontSize: { xs: '0.875rem', sm: '1rem' },  // Adjust font size for responsiveness
                      marginTop: { xs: '1rem', sm: '1.5rem' },  // Adjust margin top for spacing
                    }}
                  >
                    Session Instructions
                  </Button>
                </Grid>

                {/* Join Now Button */}
                <Grid item xs={12} sm="auto" sx={{ textAlign: 'center' }}>
                  <a href="#" onClick={handleJoinClick} style={{ textDecoration: 'none' }}>
                    <Button
                      variant="contained"
                      color="primary"
                      sx={{
                        letterSpacing: 4,
                        width: { xs: '100%', sm: 'auto' },  // Full width on small screens, auto on larger screens
                        padding: { xs: '0.75rem 1rem', sm: '0.875rem 1.5rem' },  // Adjust padding for different screen sizes
                        fontSize: { xs: '0.875rem', sm: '1rem' },  // Adjust font size for responsiveness
                        marginTop: { xs: '1rem', sm: '1.5rem' },  // Adjust margin top for spacing
                      }}
                    >
                      Join Now
                    </Button>
                  </a>
                </Grid>




              </Grid>


              <Grid container spacing={3} justifyContent="center" alignItems="center">
                <Grid item xs={12}>
                  <Typography
                    variant="h4"
                    sx={{
                      color: '#ffffff', // Light text color for dark background
                      textAlign: 'center', // Center align the heading
                      fontWeight: 600,
                      letterSpacing: 4,
                      marginTop: '2rem', // Space between heading and user list
                    }}
                  >
                    Accepted Users
                  </Typography>
                </Grid>
                {bookedUsers.length > 0 ? (
                  bookedUsers.map((user, index) => (
                    user.status !== 'rejected' && user.status !== 'cancelled' && (
                      <Grid item xs={12} sm={6} md={7} key={index}>
                        <Paper
                          sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            padding: '1.5rem',
                            borderRadius: '12px',
                            backgroundColor: '#2222', // Dark background color for better contrast
                            boxShadow: 3,
                            height: '100%',
                          }}
                        >
                          <Avatar sx={{ width: 80, height: 80, marginBottom: 2 }}>
                            <PersonOutline sx={{ color: '#ffffff' }} />
                          </Avatar>

                          <Typography
                            variant="h6"
                            sx={{
                              color: '#ffffff', // Light text for contrast on dark background
                              fontWeight: 600,
                              textAlign: 'center',
                              textDecoration: user.status === 'confirmed' ? 'underline' : 'none', // Highlight confirmed users
                              marginBottom: 5,
                              letterSpacing: 3,
                            }}
                          >
                            {user.name} {user.surname}
                          </Typography>

                          {user.status === 'confirmed' && (
                            <CancelSessionMyRequestsButton sessionId={user.id} userId={userId} />
                          )}

                          {user.status === 'confirmed' && (
                            <OTPValidationRequest postId={user.id} userId={userId} />
                          )}



                          {user.status !== 'confirmed' && (
                            <>
                              <Button
                                component={Link}
                                to={price > 0 ? `/request-payments/request/${id}/${user.id}` : '#'}
                                variant="contained"
                                fullWidth
                                sx={{
                                  marginTop: "2rem",
                                  background: "linear-gradient(45deg, #1e90ff, #1c70ff)",
                                  color: "#fff",
                                  textTransform: "none",
                                  padding: "1rem 2rem",
                                  letterSpacing: 4,
                                  fontWeight: "bold",
                                  fontSize: { xs: "1rem", sm: "1.1rem", md: "1.2rem" },
                                  borderRadius: "50px",
                                  boxShadow: "0 12px 18px rgba(0, 0, 0, 0.1)",
                                  "&:hover": {
                                    background: "linear-gradient(45deg, #1e90ff, #1c70ff)",
                                    transform: "scale(1.05)",
                                    boxShadow: "0 18px 30px rgba(0, 0, 0, 0.2)",
                                  },
                                }}
                                onClick={() => {
                                  if (price <= 0) {
                                    setOpenConfirmDialog(true);
                                  }
                                }}
                              >
                                Confirm
                              </Button>


                              <Dialog
                                open={openConfirmDialog}
                                onClose={() => setOpenConfirmDialog(false)}
                                PaperProps={{
                                  sx: {
                                    borderRadius: "16px",
                                    padding: 2,
                                    backgroundColor: "#000000", // Dark background
                                    boxShadow: "0 20px 40px rgba(0, 0, 0, 0.6)",
                                    maxWidth: 420,
                                    mx: 'auto',
                                  },
                                }}
                                transitionDuration={300}
                              >
                                <DialogTitle
                                  sx={{
                                    fontWeight: 'bold',
                                    fontSize: '1.5rem',
                                    textAlign: 'center',
                                    color: '#1E90FF', // Accent color
                                    pb: 1,
                                  }}
                                >
                                  Confirm Booking
                                </DialogTitle>

                                <DialogContent sx={{ textAlign: 'center', px: 3 }}>
                                  <Typography sx={{ fontSize: '1rem', color: '#ccc' }}>
                                    Are you sure you want to book this session?
                                  </Typography>
                                </DialogContent>

                                <DialogActions sx={{ justifyContent: 'center', gap: 2, mt: 2 }}>
                                  <Button
                                    onClick={() => setOpenConfirmDialog(false)}
                                    sx={{
                                      borderRadius: '25px',
                                      padding: '0.6rem 1.5rem',
                                      backgroundColor: '#333',
                                      color: '#ddd',
                                      textTransform: 'none',
                                      "&:hover": {
                                        backgroundColor: '#444',
                                      },
                                    }}
                                  >
                                    Cancel
                                  </Button>

                                  <Button
                                    onClick={() => {
                                      handleConfirmBooking(user.id);
                                      setOpenConfirmDialog(false);
                                    }}
                                    variant="contained"
                                    sx={{
                                      borderRadius: '25px',
                                      padding: '0.6rem 1.8rem',
                                      textTransform: 'none',
                                      background: "linear-gradient(45deg, #1e90ff, #1c70ff)",
                                      fontWeight: 'bold',
                                      letterSpacing: 1,
                                      color: '#fff',
                                      "&:hover": {
                                        transform: 'scale(1.05)',
                                        boxShadow: '0 8px 20px rgba(30, 144, 255, 0.4)',
                                      },
                                    }}
                                  >
                                    Confirm
                                  </Button>
                                </DialogActions>
                              </Dialog>

                              {/* Reject Button */}
                              <Button
                                variant="outlined"
                                fullWidth
                                sx={{
                                  marginTop: "1rem",
                                  borderColor: "#ff6347", // Red color for rejection
                                  color: "#ff6347",
                                  textTransform: "none",
                                  fontWeight: "bold",
                                  letterSpacing: 4,
                                  fontSize: { xs: "1rem", sm: "1.1rem", md: "1.2rem" },
                                  borderRadius: "50px",
                                  boxShadow: "0 12px 18px rgba(0, 0, 0, 0.1)",
                                  "&:hover": {
                                    borderColor: "#ff4500", // Dark red for hover
                                    transform: "scale(1.05)",
                                    boxShadow: "0 18px 30px rgba(0, 0, 0, 0.2)",
                                  },
                                }}
                                onClick={() => handleReject(user.id)} // Pass the user.id as bookingId to reject
                              >
                                Reject
                              </Button>
                            </>
                          )}

                          {/* Helper Texts for status */}
                          {user.status === 'confirmed' && (
                            <Typography
                              variant="body2"
                              sx={{
                                color: '#e0e0e0',
                                fontSize: '0.9rem',
                                fontStyle: 'italic',
                                marginTop: '1rem',
                                textAlign: 'center',
                                letterSpacing: 2,
                              }}
                            >
                              This user is confirmed. Please proceed with necessary actions.
                            </Typography>
                          )}
                          {user.status !== 'confirmed' && (
                            <Typography
                              variant="body2"
                              sx={{
                                color: '#e0e0e0',
                                fontSize: '0.9rem',
                                fontStyle: 'italic',
                                marginTop: '1rem',
                                textAlign: 'center',
                                letterSpacing: 2,
                              }}
                            >
                              You can confirm and pay, or reject this booking.
                            </Typography>
                          )}

                          {user.status === 'confirmed' && (
                            <FeedbackFormMyRequests sessionId={user.id} requestId={id} userId={userId} />
                          )}


                        </Paper>
                      </Grid>
                    )
                  ))
                ) : (
                  <Typography
                    variant="body1"
                    sx={{
                      color: '#ffffff',
                      textAlign: 'center',
                      fontSize: { xs: '1.2rem', sm: '1.5rem', md: '1.8rem' }, // Responsive font size
                      fontWeight: '500',
                      letterSpacing: 3,
                      marginTop: '4rem', // Add margin to top for spacing
                      padding: '0 1rem', // Ensure some horizontal padding for smaller screens
                    }}
                  >
                    No accepted users available.
                  </Typography>

                )}
              </Grid>

              <Box sx={{ textAlign: 'center', marginTop: '2rem', padding: '1rem', width: '100%' }}>

              </Box>



            </Box>
          </Grid>





          <div>


            <Dialog
              open={openDialog}
              onClose={() => setOpenDialog(false)}
              PaperProps={{
                sx: {
                  backgroundColor: '#1e1e1e',
                  color: '#e0e0e0',
                  borderRadius: 2,
                  minWidth: { xs: '90%', sm: 600 },
                  maxHeight: '90vh',
                },
              }}
            >
              <DialogContent sx={{ pt: 3, pb: 1, px: 3 }}>
                <MeetingGuidelines />

                <Box sx={{ mt: 3 }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={isChecked}
                        onChange={handleCheckboxChange}
                        sx={{
                          color: '#bb86fc',
                          '&.Mui-checked': {
                            color: '#bb86fc',
                          },
                        }}
                      />
                    }
                    label={
                      <Typography variant="body2" sx={{ color: '#e0e0e0', letterSpacing: 2 }}>
                        I acknowledge that I have read, understood, and agree to all the terms and conditions outlined above.
                      </Typography>
                    }
                  />
                </Box>
              </DialogContent>

              <DialogActions sx={{ px: 3, pb: 3 }}>
                <Button
                  onClick={() => setOpenDialog(false)}
                  variant="outlined"
                  color="secondary"
                  sx={{ letterSpacing: 3 }}
                >
                  Cancel
                </Button>
                <Button
                  onClick={handleConfirmAndJoin}
                  variant="contained"
                  color="primary"
                  disabled={!isChecked}
                  sx={{
                    backgroundColor: !isChecked ? '#555' : '#1976d2',
                    letterSpacing: 3,
                    '&:hover': {
                      backgroundColor: !isChecked ? '#555' : '#1565c0',
                    },
                  }}
                >
                  Confirm and Join
                </Button>
              </DialogActions>
            </Dialog>


          </div>

        </Grid>



      </Box>

      <IconButton
        onClick={scrollToTop}
        sx={{ position: 'fixed', bottom: 16, right: 16, backgroundColor: 'white', color: 'black' }}>
        <ArrowUpwardIcon />
      </IconButton>
      <Footer2 />
    </div>
  );
};

export default MyRequestTabDetails;